import { MutationTree } from 'vuex';
import { State } from './state';
import { TargetsApiResponse } from './types';

export enum TargetsMutationTypes {
  SET_TARGETS_DATA = 'SET_TARGETS_DATA',
  SET_LOADING = 'SET_LOADING',
}

export type Mutations<S = State> = {
  [TargetsMutationTypes.SET_TARGETS_DATA](
    state: S,
    payload: TargetsApiResponse
  ): void;
  [TargetsMutationTypes.SET_LOADING](state: S, payload: boolean): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [TargetsMutationTypes.SET_TARGETS_DATA](state, payload) {
    state.targets = payload;
  },
  [TargetsMutationTypes.SET_LOADING](state, payload) {
    state.loading = payload;
  },
};
